import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { clearAuthSession } from "../utils/auth";

const roleLabels = {
  admin: "Genmech Admin",
  lg_admin: "LG Admin",
  engineer: "Engineer"
};

const timeInIst = () => new Intl.DateTimeFormat("en-IN", {
  timeZone: "Asia/Kolkata",
  dateStyle: "full",
  timeStyle: "medium"
}).format(new Date());

export default function AttendanceShell({ role, profile, children }) {
  const navigate = useNavigate();
  const [clock, setClock] = useState(timeInIst());

  useEffect(() => {
    const timer = window.setInterval(() => setClock(timeInIst()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  const signOut = () => {
    clearAuthSession();
    navigate("/attendance", { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900">
      <header className="border-b border-slate-800 bg-slate-950 text-white">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-4 py-4 sm:px-6">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-amber-300">Genmech Services · LG</p>
            <h1 className="mt-1 text-xl font-black sm:text-2xl">Attendance & Work Approval</h1>
          </div>
          <div className="flex items-center gap-3 text-right">
            <div className="hidden sm:block">
              <p className="text-sm font-semibold">{profile || roleLabels[role]}</p>
              <p className="mt-0.5 text-xs text-slate-300">{clock}</p>
            </div>
            <button type="button" onClick={signOut} className="rounded-xl border border-slate-600 px-3 py-2 text-sm font-semibold transition hover:border-amber-300 hover:text-amber-200">
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-5 sm:px-6 sm:py-8">{children}</main>
    </div>
  );
}
